import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { updateBackAction } from '../../../../redux/providerBuilder/stepperDetails';
import { getBackAction } from '../../../../redux/providerBuilder/stepperDetails/selectors';
import { getSessionId } from '../../../../redux/session/selectors';
import { sendDevtoolLogs } from '../../../../utils/logs/send-logs';
import { SessionIdDisplay } from './session-id.component';

interface InitialiseSessionProps {
  accessToken: string;
  userUid: string;
}

export const InitialiseSession = (props: InitialiseSessionProps) => {
  const dispatch = useAppDispatch();
  const sessionId = useAppSelector(getSessionId);
  const { accessToken, userUid } = props;
  const backActionUsed = useAppSelector(getBackAction);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isEdit = searchParams.get('isEdit');

  const navigate = useNavigate();

  useEffect(() => {
    sendDevtoolLogs('PROVIDER_INITD');
  }, []);

  useEffect(() => {
    if (backActionUsed) {
      dispatch(updateBackAction(false));
    }
  }, [backActionUsed, dispatch]);

  useEffect(() => {
    if (isEdit) {
      navigate('/provider-builder');
    }
  }, [isEdit, sessionId, location.pathname]);

  return sessionId ? (
    <SessionIdDisplay sessionId={sessionId} accessToken={accessToken} userUid={userUid} />
  ) : null;
};
